<template>
    <v-combobox
        v-model="selectedIcon"
        v-model:search="searchTerm"
        :hide-no-data="false"
        :items="filteredIcons"
        item-title="label"
        item-value="name"
        :custom-filter="() => true"
        label="Search icons"
        clearable
        :menu-props="{ maxHeight: 300 }"
        :return-object="false"
        @click:clear="handleClear"
        @update:model-value="emitSelection"
        contained
        location-strategy="connected"
    >
        <template #item="{ props, item }">
        <v-list-item v-bind="{ ...props, title: item.raw.name }" @mousedown.prevent>
            <template #prepend>
            <v-icon :icon="item.raw.name" size="24" />
            </template>
        </v-list-item>
        </template>
        <template #no-data>
        <v-list-item v-if="searchTerm" @mousedown.prevent="handleGenerate" style="cursor: pointer;">
            <template #prepend>
            <v-icon icon="mdi-robot"/>
            </template>
            <v-list-item-title>No icon found for "<strong>{{ searchTerm }}</strong>"</v-list-item-title>
            <v-list-item-subtitle>Click to generate an icon using AI based on the search term.</v-list-item-subtitle>
        </v-list-item>
        </template>
    </v-combobox>
</template>

<script>
import { fuzzySearchIcons } from '../helpers/fuzzySearchIcons';

export default {
    data: () => ({
        selectedIcon: null,
        searchTerm: ''
    }),
    props: ['prepopulatedSearchTerm'],
    emits: ['generateIcon', 'clearSearch', 'update:modelValue'],
    watch: {
        searchTerm(newValue) {
            if (newValue === '') {
                this.selectedIcon = null;
                this.handleClear();
            }
        },
        prepopulatedSearchTerm: {
            handler(newValue) {
                if (newValue) {
                    this.searchTerm = newValue || '';
                    this.selectedIcon = newValue || '';
                } else {
                    this.searchTerm = '';
                    this.selectedIcon = null;
                }
            },
            immediate: true
        }
    },
    computed: {
        filteredIcons() {
        return fuzzySearchIcons(this.searchTerm);
        }
    },
    methods: {
        handleClear(){
            this.$emit('clearSearch');
        },
        handleGenerate() {
            this.$emit('generateIcon', this.searchTerm);
        },
        emitSelection() {
            this.$emit('update:modelValue', this.selectedIcon);
        }
    }
}
</script>